export default __webpack_public_path__ + "static/media/intro1.6b318865.mp3";